export default{
	// baseUrl: "http://api-gen-air.test/api"
	baseUrl: "https://api-gen-air.viserx.dev/api"
}